var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_876_1447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9687 6.21798C13.4515 6.21798 13.6531 5.59767 13.2609 5.31173L7.29368 0.971109C7.20847 0.908674 7.10558 0.875015 6.99994 0.875015C6.89429 0.875015 6.7914 0.908674 6.70619 0.971109L0.738997 5.31173C0.346809 5.59611 0.548372 6.21798 1.03275 6.21798H1.99993V12.0617H0.874934C0.806184 12.0617 0.749934 12.118 0.749934 12.1867V12.9992C0.749934 13.068 0.806184 13.1242 0.874934 13.1242H13.1249C13.1937 13.1242 13.2499 13.068 13.2499 12.9992V12.1867C13.2499 12.118 13.1937 12.0617 13.1249 12.0617H11.9999V6.21798H12.9687ZM6.99994 2.07267L11.2359 5.15392H2.764L6.99994 2.07267ZM3.12493 6.21798H4.95306V12.0617H3.12493V6.21798ZM6.07806 6.21798H7.90619V12.0617H6.07806V6.21798ZM10.8749 12.0617H9.03119V6.21798H10.8749V12.0617Z",
    fill: "#B6BED4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_876_1447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.aee85d85585b5581c0feba8669d4cf0c.svg";
export { ForwardRef as ReactComponent };